import { SpiceLevel } from 'common/SpiceLevels';
import { Slugs } from 'common/urls/Slugs';
import { useMemo } from 'react';
import { Routes } from 'src/shared/Routes';
import { DIETARY_TAG_DISPLAY_ORDER, dietaryTagToFoodItemFilter } from 'src/shared/utils/diet-utils';
import { DisplayedFoodItemTags } from 'src/shared/utils/IconUtils';
import { getSluggedPath } from 'src/shared/utils/RouteUtilities';
import { UseDishPathProps } from './types';

export const useDietaryTags = (foodItem: DisplayedFoodItemTags) => {
  const dietaryTags = useMemo(
    () => DIETARY_TAG_DISPLAY_ORDER.filter((dietaryTag) => dietaryTagToFoodItemFilter[dietaryTag](foodItem)),
    [foodItem]
  );
  return { showDietaryTags: dietaryTags.length > 0 || foodItem.spiceLevel !== SpiceLevel.NOT_SPICY, dietaryTags };
};

export const useDishPath = (props: UseDishPathProps) => {
  const { shefId, dishSlug } = props;

  return getSluggedPath(Routes.CONSUMER_ORDER_FOOD_ITEM, [
    { slug: Slugs.ID, value: shefId ?? '' },
    { slug: Slugs.NAME, value: dishSlug ?? '' },
  ]);
};
